import SectionHeader from "./SectionHeader";

const BRANDS = ["SONY", "Nikon", "Canon", "GoPro"];

// static brand strip (text wordmarks — no brand logo assets in the project)
export default function Brands() {
  return (
    <section className="mb-20">
      <div className="container mx-auto">
        <SectionHeader title="Top Brands" />
        <div className="grid grid-cols-2 md:grid-cols-4 gap-[15px] md:gap-[30px]">
          {BRANDS.map((brand) => (
            <div
              key={brand}
              className="h-20 rounded-card bg-white text-neutral-900 flex items-center justify-center font-display text-xl font-bold tracking-wide shadow-card">
              {brand}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
